import { useCallback, useEffect, useState } from 'react';
import { useProfilingProgressContext } from '../../providers/ProfilingProgressProvider/ProfilingProgress.context';
import SyncProgressToast from './SyncProgressToast.component';

export default function SyncProgressToastContainer() {
  const profilingState = useProfilingProgressContext();

  const [dismissed, setDismissed] = useState(false);
  const [showCompleted, setShowCompleted] = useState(false);
  const [wasActive, setWasActive] = useState(false);

  useEffect(() => {
    if (profilingState.active) {
      setWasActive(true);
      setDismissed(false);
    }
  }, [profilingState.active]);

  // Show completed toast when profiling finishes (was active, now done)
  useEffect(() => {
    if (
      wasActive &&
      !profilingState.active &&
      profilingState.total > 0 &&
      profilingState.profiled >= profilingState.total
    ) {
      setShowCompleted(true);
    }
  }, [wasActive, profilingState.active, profilingState.total, profilingState.profiled]);

  const handleDismiss = useCallback(() => {
    setDismissed(true);
    setShowCompleted(false);
  }, []);

  if (!showCompleted || dismissed) return null;

  return (
    <SyncProgressToast
      phase="completed"
      profiled={profilingState.profiled}
      total={profilingState.total}
      funnelId={profilingState.funnelId}
      onDismiss={handleDismiss}
    />
  );
}
